import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import TooltipLable from './tooltip-label';
import { emptyArray } from 'ui-components/default-props/empty';
import style from './style.module.less';
import messages from './messages';

const CustomTooltipItemsSoldOverTime = ({ payload = emptyArray }) => {
  const selectedDate = payload?.[0]?.payload.interval;
  const sumValuesOfPayload = payload?.reduce((total, item) => total + item.value, 0);

  const categoryDisplayMap = payload?.map((datum) => {
    const formatNumber = datum.value !== 0 ? <FormattedNumber value={datum.value} /> : null;
    const categoryName = datum.value !== 0 ? datum.dataKey : null;
    return (
      <div key={datum.dataKey} className={style.content}>
        <FormattedMessage
          {...messages.itemsSoldOverTime}
          values={{
            formatNumber,
            categoryName,
          }}
        />
      </div>
    );
  });

  const displayMessage = () => {
    if (sumValuesOfPayload === 0) {
      return (
        <div className={style.content}>
          <FormattedMessage {...messages.itemsSoldOverTimeNoSales} />
        </div>
      );
    }
    return categoryDisplayMap;
  };

  return (
    <>
      <TooltipLable selectedDate={selectedDate} />
      {displayMessage()}
    </>
  );
};

CustomTooltipItemsSoldOverTime.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        interval: PropTypes.string,
        value: PropTypes.number,
        dataKey: PropTypes.string,
      }),
    }),
  ),
};

export default CustomTooltipItemsSoldOverTime;
